import { Component, computed, effect, inject, input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { AvatarComponent } from '../../components/avatar/avatar.component';
import { TemplateDirective } from '../../directives/template.directive';
import { GroupPickerHandler } from '../smart-input-entity/group-picker.handler';
import { BaseGroupDto } from '@api/backend-connector/models';
import { SmartInputEntityComponent } from 'src/app/components-form/smart-input-entity/smart-input-entity.component';
import { GroupsService } from 'src/app/services/groups.service';
import { UIProjectGroupsService } from 'src/app/services/ui-project-groups.service';
import { cast } from 'src/app/utils';

@Component({
  selector: 'app-group-picker',
  templateUrl: './group-picker.component.html',
  styleUrl: './group-picker.component.scss',
  standalone: true,
  imports: [AvatarComponent, SmartInputEntityComponent, TemplateDirective],
})
export class GroupPickerComponent {
  private readonly groupsService = inject(GroupsService);
  private readonly uIProjectGroupsService = inject(UIProjectGroupsService);

  readonly control = input.required<FormControl<BaseGroupDto | null | undefined>>();
  readonly projectId = input<string>();
  readonly onlyAssignable = input<boolean>();
  readonly placeholder = input('');
  readonly resetValue = input<BaseGroupDto>();
  readonly excludeIds = input<string[] | null>();

  readonly groupPickerHandler = computed(() => {
    void this.resetValue();
    return new GroupPickerHandler(this.groupsService, this.uIProjectGroupsService, {
      projectId: this.projectId(),
      onlyAssignable: this.onlyAssignable(),
    });
  });

  readonly cast = cast<BaseGroupDto>;

  constructor() {
    effect(() => {
      this.groupPickerHandler().setExcludeIds(this.excludeIds() ?? []);
    });
  }
}
